<div class="container-fluid">
  <app-video-metadata-update-form/>
</div>
